<template>
  <div class="container mx-auto h-full py-5">
    <el-dialog
      title="Vista previa de contrato"
      :visible.sync="showPreviewDialog"
      width="1000px"
      :close-on-click-modal="false"
    >
      <new-tab-overview :values="editDialog.data" :hide-buttons="true" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showPreviewDialog = false"
          >Cancelar</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="Editar contrato"
      :visible.sync="showEditDialog"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="editDialog.tab">
        <el-tab-pane label="General" name="general">
          <new-tab-general
            :values="editDialog.data.general"
            next-name="Guardar"
            :require-confirm="true"
            :key="editDialog.data.general.id"
            :show-cancel="true"
            @save="afterUpdateContract"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Documentos" name="documents">
          <new-tab-documents
            :key="editDialog.data.general.id"
            :values="editDialog.data.documents"
            next-name="Guardar"
            :require-confirm="true"
            :country="editDialog.data.general.country"
            :contract-id="editDialog.data.general.id"
            :show-cancel="true"
            @save="afterUpdateContract"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
        <el-tab-pane label="Laboral" name="laboral">
          <new-tab-laboral
            :key="editDialog.data.general.id"
            :contract-id="editDialog.data.general.id"
            :values="editDialog.data.laboral"
            next-name="Guardar"
            :require-confirm="true"
            :show-cancel="true"
            @save="afterUpdateContract"
            @cancel="showEditDialog = false"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15" type="flex" justify="space-between">
          <el-col :span="10">
            <h3 class="text-l font-semibold">TODOS LOS CONTRATOS EN PROCESO</h3>
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchEmployee"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mt-5">
          <el-col :span="24">
            <el-table
              :data="filteredEmployees"
              stripe
              size="mini"
              v-if="show"
              @selection-change="updateSelections"
              ref="employeesTable"
            >
              <el-table-column
                :type="typeSelection ? 'selection' : 'index'"
                min-width="40"
              />
              <el-table-column label min-width="50">
                <template slot-scope="scope">
                  <img :src="photo(scope.row)" class="w-8 h-8 rounded-full" />
                </template>
              </el-table-column>
              <el-table-column label="Nombre" min-width="300">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.name1 }}
                    {{ scope.row.name2 }}
                    {{ scope.row.name3 }}
                    {{ scope.row.lastname1 }}
                    {{ scope.row.lastname2 }}
                    {{ scope.row.lastname3 }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Puesto" min-width="160">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.department !== null
                      ? scope.row.department.name
                      : ""
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Salario inicial" min-width="90">
                <template slot-scope="scope">
                  <span>{{ scope.row.currentSalary | formatMoney }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Tipo de contrato" min-width="170">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.contractType !== null
                      ? scope.row.contractType.name
                      : ""
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Inicio de contrato" min-width="125">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.contractStartDate | formatDate("YYYY-MM-DD")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Fin de contrato" min-width="125">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.contractEndDate | formatDate("YYYY-MM-DD")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="100">
                <template slot-scope="scope">
                  <el-tag
                    size="small"
                    type="success"
                    v-if="isContractComplete(scope.row)"
                    >Completo</el-tag
                  >
                  <el-tag size="small" type="danger" v-else>Incompleto</el-tag>
                </template>
              </el-table-column>
              <el-table-column min-width="70" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="openPreviewDialog(scope.row)"
                      >
                        <i class="el-icon-fa-eye"></i> Ver detalles
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.native="openEditDialog(scope.row)"
                      >
                        <i class="el-icon-fa-pencil"></i> Editar contrato
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <i class="el-icon-fa-print"></i> Imprimir contrato
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="isContractComplete(scope.row)"
                        :divided="true"
                        class="text-green-500 font-semibold"
                        @click.native="toRegister(scope.row)"
                      >
                        <i class="el-icon-fa-check"></i> Dar de alta
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteContract(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rawEmployees.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";
import * as generator from "generate-password";

import NewTabGeneral from "./NewTabGeneral";
import NewTabDocuments from "./NewTabDocuments";
import NewTabLaboral from "./NewTabLaboral";
import NewTabOverview from "./NewTabOverview";

import photo from "./../../../assets/imgs/picture.jpg";

export default {
  name: "ContractsAll",
  components: { NewTabGeneral, NewTabDocuments, NewTabLaboral, NewTabOverview },
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          employees (where: { status: 1 }) {
            id
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            dob
            currentSalary
            documents { expedition expiration number }
            image
            currentSalary
            contractStartDate
            contractEndDate
            contractComplete
            department { name }
            contractType { name }
            status { name }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.employees));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      searchEmployee: "",
      page: { size: 15, number: 1 },
      rawEmployees: [],
      typeSelection: false,
      show: true,
      hasSelections: false,
      showAddSupervisor: false,
      addSupervisorForm: {
        supervisor1: null,
        supervisor2: null,
      },
      addSupervisorFormRules: {
        supervisor1: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "change",
          },
        ],
      },
      supervisors: [],
      employeesToEdit: [],
      showEditDialog: false,
      editDialog: {
        tab: "general",
        data: {
          general: {
            id: null,
            name1: null,
            name2: null,
            name3: null,
            lastname1: null,
            lastname2: null,
            lastname3: null,
            dob: null,
            address1: null,
            address2: null,
            country: null,
            state: null,
            city: null,
            sex: 1,
          },
          documents: [],
          laboral: {
            contractType: null,
            department: null,
            contractStartDate: null,
            contractEndDate: null,
            currentSalary: null,
          },
        },
      },
      showPreviewDialog: false,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
    },
    setData(data) {
      this.rawEmployees = data;
    },
    photo() {
      return photo;
    },
    updateType() {
      this.typeSelection = !this.typeSelection;
      if (!this.typeSelection) this.hasSelections = false;
      this.reload();
    },
    reload() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    updateSelections() {
      this.hasSelections = this.$refs.employeesTable.selection.length > 0;
    },
    openAddSupervisor() {
      if (!R.isEmpty(this.$refs.employeesTable.selection.length)) {
        this.employeesToEdit = this.$refs.employeesTable.selection;
      }
      axios
        .post("/", {
          query: `{
          employees { id name1 name2 lastname1 lastname2 }
        }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.supervisors = data.employees;
            this.addSupervisorForm.supervisor1 = null;
            this.addSupervisorForm.supervisor2 = null;
            this.showAddSupervisor = true;
          }
        });
    },
    submitAddSupervisor(formName, employees, supervisors) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          `¿Estás seguro que deseas asignar estos supervisores a los empleados seleccionados?`,
          "Confirmación",
          {
            confirmButtonText: `Si, asignar`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      assingSupervisors(
                        employees: ${JSON.stringify(JSON.stringify(employees))}
                        supervisors: ${JSON.stringify(
                          JSON.stringify(supervisors)
                        )}
                      )
                      { 
                        id
                        name1
                        name2
                        name3
                        lastname1
                        lastname2
                        lastname3
                        image
                        currentSalary
                        contractStartDate
                        contractEndDate
                        department { name }
                        contractType { name }
                        status { name }
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawEmployees = data.assingSupervisors;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se han asignado los supervisores a los empleados seleccionados`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showAddSupervisor = false;
                    this.typeSelection = false;
                    this.hasSelections = false;
                    this.reload();
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, asignar`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    toRegister(contract) {
      this.$confirm(
        "¿Estás seguro que deseas dar de alta este contrato?",
        "Confirmación",
        {
          confirmButtonText: "Si, porfavor",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    toRegisterEmployee(id: "${contract.id}") { 
                      id
                      name1
                      name2
                      name3
                      lastname1
                      lastname2
                      lastname3
                      image
                      currentSalary
                      contractStartDate
                      contractEndDate
                      contractComplete
                      department { name }
                      contractType { name }
                      status { name }
                     } 
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha dado de alta al empleado correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  this.rawEmployees = data.toRegisterEmployee;
                  done();
                })
                .catch(console.log)
                .then((alw) => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, guardar";
                });
            } else {
              done();
            }
          },
        }
      );
    },
    deleteContract(contract) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este contrato?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    contractDelete(where: {id: "${contract.id}"}) { 
                      id
                      name1
                      name2
                      name3
                      lastname1
                      lastname2
                      lastname3
                      dob
                      currentSalary
                      image
                      currentSalary
                      contractStartDate
                      contractEndDate
                      contractComplete
                      department { name }
                      contractType { name }
                      status { name }
                     } 
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el contrato correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  this.rawEmployees = data.contractDelete;
                  done();
                })
                .catch(console.log)
                .then((alw) => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openEditDialog({ id }) {
      axios
        .post("/", {
          query: `{
            employee (where: { id: "${id}" }) {
              id
              name1 name2 name3
              lastname1 lastname2 lastname3
              dob
              address1 address2
              country { id } state { id } city { id }
              sex,
              documents { documentType { id mask } expedition expiration number }
              contractType { id }
              paysheetType { id }
              department { id }
              contractStartDate contractEndDate
              currentSalary
            }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          const doptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          };

          this.editDialog.data.documents = [];
          for (const document of data.employee.documents) {
            const { expedition, expiration, number } = document;
            const { id, mask } = document.documentType;
            this.editDialog.data.documents.push({
              expedition:
                expedition === null
                  ? null
                  : new Intl.DateTimeFormat("es-ES", doptions).format(
                      new Date(expedition).setDate(
                        new Date(expedition).getDate() + 1
                      )
                    ),
              expiration:
                expiration === null
                  ? null
                  : new Intl.DateTimeFormat("es-ES", doptions).format(
                      new Date(expiration).setDate(
                        new Date(expiration).getDate() + 1
                      )
                    ),
              number,
              mask: mask,
              documentType: id,
            });
          }

          delete data.employee.documents;
          this.editDialog.data.general = {
            id: data.employee.id,
            name1: data.employee.name1,
            name2: data.employee.name2,
            name3: data.employee.name3,
            lastname1: data.employee.lastname1,
            lastname2: data.employee.lastname2,
            lastname3: data.employee.lastname3,
            dob: new Intl.DateTimeFormat("es-ES", doptions).format(
              new Date(data.employee.dob).setDate(
                new Date(data.employee.dob).getDate() + 1
              )
            ),
            address1: data.employee.address1,
            address2: data.employee.address2,
            country: data.employee.country.id,
            state: data.employee.state.id,
            city: data.employee.city.id,
            sex: data.employee.sex,
          };
          this.editDialog.data.laboral = {
            contractType: R.isNil(data.employee.contractType)
              ? null
              : data.employee.contractType.id,
            department: R.isNil(data.employee.department)
              ? null
              : data.employee.department.id,
            contractStartDate:
              data.employee.contractStartDate === null
                ? null
                : new Intl.DateTimeFormat("es-ES", doptions).format(
                    new Date(data.employee.contractStartDate).setDate(
                      new Date(data.employee.contractStartDate).getDate() + 1
                    )
                  ),
            contractEndDate:
              data.employee.contractEndDate === null
                ? null
                : new Intl.DateTimeFormat("es-ES", doptions).format(
                    new Date(data.employee.contractEndDate).setDate(
                      new Date(data.employee.contractEndDate).getDate() + 1
                    )
                  ),
            currentSalary: data.employee.currentSalary,
            paysheetType:
              data.employee.paysheetType !== null
                ? data.employee.paysheetType.id
                : null,
          };
          this.showEditDialog = true;
        });
    },
    afterUpdateContract(data) {
      axios
        .post("/", {
          query: `{
          employees (where: { status: 1 }) {
            id
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            dob
            currentSalary
            documents { expedition expiration number }
            image
            currentSalary
            contractStartDate
            contractEndDate
            contractComplete
            department { name }
            contractType { name }
            status { name }
          }
        }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.rawEmployees = data.employees;
          }
          this.showEditDialog = false;
        });
    },
    openPreviewDialog({ id }) {
      axios
        .post("/", {
          query: `{
            employee (where: { id: "${id}" }) {
              id
              name1 name2 name3
              lastname1 lastname2 lastname3
              dob
              address1 address2
              country { id } state { id } city { id }
              sex,
              documents { documentType { id mask } expedition expiration number }
              contractType { id }
              paysheetType { id }
              department { id }
              contractStartDate contractEndDate
              currentSalary
            }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          const doptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          };

          this.editDialog.data.documents = [];
          for (const document of data.employee.documents) {
            const { expedition, expiration, number } = document;
            const { id, mask } = document.documentType;
            this.editDialog.data.documents.push({
              expedition:
                expedition === null
                  ? null
                  : new Intl.DateTimeFormat("es-ES", doptions).format(
                      new Date(expedition).setDate(
                        new Date(expedition).getDate() + 1
                      )
                    ),
              expiration:
                expiration === null
                  ? null
                  : new Intl.DateTimeFormat("es-ES", doptions).format(
                      new Date(expiration).setDate(
                        new Date(expiration).getDate() + 1
                      )
                    ),
              number,
              mask: mask,
              documentType: id,
            });
          }

          delete data.employee.documents;
          this.editDialog.data.general = {
            id: data.employee.id,
            name1: data.employee.name1,
            name2: data.employee.name2,
            name3: data.employee.name3,
            lastname1: data.employee.lastname1,
            lastname2: data.employee.lastname2,
            lastname3: data.employee.lastname3,
            dob: new Intl.DateTimeFormat("es-ES", doptions).format(
              new Date(data.employee.dob).setDate(
                new Date(data.employee.dob).getDate() + 1
              )
            ),
            address1: data.employee.address1,
            address2: data.employee.address2,
            country: data.employee.country.id,
            state: data.employee.state.id,
            city: data.employee.city.id,
            sex: data.employee.sex,
          };
          this.editDialog.data.laboral = {
            contractType: R.isNil(data.employee.contractType)
              ? null
              : data.employee.contractType.id,
            department: R.isNil(data.employee.department)
              ? null
              : data.employee.department.id,
            contractStartDate:
              data.employee.contractStartDate === null
                ? null
                : new Intl.DateTimeFormat("es-ES", doptions).format(
                    new Date(data.employee.contractStartDate).setDate(
                      new Date(data.employee.contractStartDate).getDate() + 1
                    )
                  ),
            contractEndDate:
              data.employee.contractEndDate === null
                ? null
                : new Intl.DateTimeFormat("es-ES", doptions).format(
                    new Date(data.employee.contractEndDate).setDate(
                      new Date(data.employee.contractEndDate).getDate() + 1
                    )
                  ),
            currentSalary: data.employee.currentSalary,
            paysheetType:
              data.employee.paysheetType !== null
                ? data.employee.paysheetType.id
                : null,
          };

          this.showPreviewDialog = true;
        });
    },
    isContractComplete(contract) {
      const { dob, currentSalary, documents } = contract;
      return !R.or(R.isNil(dob), R.isNil(currentSalary));
    },
  },
  computed: {
    filteredEmployees() {
      return this.rawEmployees
        .filter((employee) => {
          const search = this.searchEmployee.toLowerCase();
          const {
            name1,
            name2,
            name3,
            lastname1,
            lastname2,
            lastname3,
            department,
            contractType,
            status,
          } = employee;
          let fullName = "";
          fullName += R.isNil(name1) ? "" : `${name1} `;
          fullName += R.isNil(name2) ? "" : `${name2} `;
          fullName += R.isNil(name3) ? "" : `${name3} `;
          fullName += R.isNil(lastname1) ? "" : `${lastname1} `;
          fullName += R.isNil(lastname2) ? "" : `${lastname2} `;
          fullName += R.isNil(lastname2) ? "" : `${lastname2} `;
          fullName += R.isNil(lastname3) ? "" : `${lastname3} `;

          return (
            fullName.toLowerCase().includes(search) ||
            department.name.toLowerCase().includes(search) ||
            contractType.name.toLowerCase().includes(search) ||
            status.name.toLowerCase().includes(search)
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
